// #region Imports
import React, { useState } from 'react';
import { useProdutos } from '../../hooks/useProdutos';
import ProdutosTable from '../../components/Produtos/ProdutoTable/ProdutosTable';
import ProdutoCrud from '../../components/Produtos/ProdutoCrud/ProdutoCrud';
import './Produtos-Page.scss';
// #endregion

export default function ProdutosPage() {
  // #region Hook domínio
  const {
    loading,
    items,
    total,
    page,
    pageSize,
    setPage,
    searchDraft,
    onChangeSearch,
    commitSearch,
    stats,
    saveProduto,
    removeProduto,
  } = useProdutos();
  // #endregion

  // #region Estado local modal
  const [crudOpen, setCrudOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  // #endregion

  // #region Handlers CRUD UI
  function openNovo() { setEditing(null); setCrudOpen(true); }
  function openEdit(p) { setEditing(p); setCrudOpen(true); }
  function handleDelete(p) { if (window.confirm(`Tem certeza que deseja excluir o produto "${p.nome}"?`)) removeProduto(p.id); }
  // #endregion

  // #region Render
  return (
    <div className="produtos-page">
      <ProdutosTable
        loading={loading}
        stats={stats}
        filters={{ search: searchDraft }}
        onFiltersChange={({ search }) => { onChangeSearch(search); }}
        onCommitFilters={commitSearch}
        items={items}
        total={total}
        page={page}
        pageSize={pageSize}
        onPageChange={setPage}
        onCreate={openNovo}
        onEdit={openEdit}
        onDelete={handleDelete}
      />
      <ProdutoCrud
        open={crudOpen}
        editing={editing}
        onClose={() => setCrudOpen(false)}
        onSave={saveProduto}
      />
    </div>
  );
  // #endregion
}